import createMessageReceiver from "./create-message-receiver";
import debounce from "./debounce";
import getExperienceId from "./get-experience-id";
import getIframeUrl from "./get-iframe-url";
import getOrigin from "./get-origin";
import getSnippetElements from "./get-snippet-elements";
import getUserId from "./get-user-id";
import maximize from "./maximize";
import resizeIframe from "./resize-iframe";
import state from "./state";

/**
 * Converts embed snippet into embedded iframe
 *
 * @returns {undefined}
 */
export default function createEmbed() {
  const { convo, link, span } = getSnippetElements();

  state.set({
    experienceId: getExperienceId(link.href),
    origin: getOrigin(link.href),
    scrollPos: {
      x: 0,
      y: 0
    },
    userId: getUserId()
  });

  const iframe = document.createElement("iframe");
  iframe.onload = () => {
    try {
      link.removeChild(span);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  };
  iframe.name = "speakeasy";
  iframe.setAttribute("allow", "fullscreen; microphone; payment");
  iframe.src = getIframeUrl(link.href);
  iframe.title = "Conversational Media Experience from Forever Holdings";

  if (convo.hasAttribute("data-maximized")) {
    maximize(iframe);
  } else {
    resizeIframe(iframe, convo);
  }

  document.body.appendChild(iframe);

  window.addEventListener(
    "message",
    createMessageReceiver(iframe, convo),
    false
  );
  window.addEventListener(
    "resize",
    () => debounce(() => resizeIframe(iframe, convo)),
    false
  );
}
